import React from 'react';
import Select from 'react-select';
import { BeatLoader } from 'react-spinners';

import { callApi } from 'helpers/callApi/callApi';
import styles from './PreviewEmail.module.scss';
import { PreviewEmailProps, PreviewEmailState, TemplateData } from './PreviewEmail.types';
import { SendPreviewFormContainer } from './sendPreview/SendPreviewForm';

export class PreviewEmail extends React.Component<PreviewEmailProps, PreviewEmailState> {
  state = {
    html: '',
    loading: false,
    error: false,
    data: [] as TemplateData[],
    templateId: '',
  };

  componentDidMount(): void {
    const { fetchEmailsTemplatesIds } = this.props;
    this.setState({ data: [], loading: true, error: false });

    callApi({
      action: () => fetchEmailsTemplatesIds(),
      onSuccess: ({ payload }) => {
        this.setState({ data: payload, loading: false, error: false });
      },
      onFailure: () => {
        this.setState({ data: [], loading: false, error: true });
      },
    });
  }

  onTemplateChange = (event: any) => {
    const { getEmailTemplate } = this.props;
    this.setState({ html: '', loading: true, error: false, templateId: event.value });

    callApi({
      action: () => getEmailTemplate(event.value),
      onSuccess: ({ payload }) => {
        this.setState({ html: payload.html, loading: false, error: false });
      },
      onFailure: () => {
        this.setState({ html: '', loading: false, error: true });
      },
    });
  };

  render() {
    const { html, loading, error, data, templateId } = this.state;
    const { sendEmailTemplate } = this.props;

    return (
      <div className={styles.tabWrapper}>
        <Select
          options={data.map((el: any) => {
            return { value: el.id, label: el.name };
          })}
          onChange={this.onTemplateChange}
          isSearchable
        />
        {templateId && (
          <SendPreviewFormContainer
            sendEmailTemplate={sendEmailTemplate}
            templateId={templateId}
            templateLoading={loading}
          />
        )}
        {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
        <div
          //  eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: html }}
          onClick={event => event.preventDefault()}
          className={styles.htmlPreview}
        />
        <div className={styles.loaderWrapper}>{loading && <BeatLoader />}</div>
        {error && <div className={styles.errorWrapper}>Something goes wrong...</div>}
      </div>
    );
  }
}
